import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Profile: React.FC = () => (
  <Box>
    <Typography variant="h4" gutterBottom>Mi Perfil</Typography>
    <Paper sx={{ p: 3, mt: 2 }}>
      <Typography>Configuración del perfil de usuario</Typography>
    </Paper>
  </Box>
);

export default Profile;